import isDev from "./isDev";

export const getGitHubStatsImageUrlMap = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return {
    dark: `${siteOrigin}/${username}/github?theme=dark`,
    light: `${siteOrigin}/${username}/github?theme=light`,
  };
};

export const getLanguagesOverTimeImageUrlMap = (
  username: string | undefined
) => {
  const siteOrigin = getSiteOrigin();
  return {
    dark: `${siteOrigin}/${username}/languages-over-time?theme=dark`,
    light: `${siteOrigin}/${username}/languages-over-time?theme=light`,
  };
};

export const getTopicsOverTimeImageUrlMap = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return {
    dark: `${siteOrigin}/${username}/topics-over-time?theme=dark`,
    light: `${siteOrigin}/${username}/topics-over-time?theme=light`,
  };
};

export const getStackOverflowAchievementsImageUrl = (
  username: string | undefined
) => {
  const siteOrigin = getSiteOrigin();
  return {
    dark: `${siteOrigin}/${username}/stack-overflow?theme=dark`,
    light: `${siteOrigin}/${username}/stack-overflow?theme=light`,
  };
};

export const getPoapImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/poap`;
};

export const getGitPoapImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/git-poap`;
};

export const getSnapshotImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/snapshot`;
};

export const getWeb3ImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return {
    dark: `${siteOrigin}/${username}/web3?theme=dark`,
    light: `${siteOrigin}/${username}/web3?theme=light`,
  };
};

export const getLanguageVerificationImageUrl = (
  username: string | undefined
) => {
  const siteOrigin = getSiteOrigin();
  return {
    base: `${siteOrigin}/${username}/verified-languages`,
    legends: `${siteOrigin}/${username}/verified-languages?simple=true`,
  };
};

export const getDeveloperDAOImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/dev-dao`;
};

export const getDevToImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/dev-to`;
};

export const getPhilandImageUrl = (
  username: string | undefined,
  ensDomain?: string
) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/philand-mumbai/${ensDomain}`;
};

export const getDiscordProfileImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/discord`;
};

export const getKaggleImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/kaggle`;
};

export const getMirrorImageUrl = (username: string | undefined) => {
  const siteOrigin = getSiteOrigin();
  return `${siteOrigin}/${username}/mirror`;
};

export const getSiteOrigin = () => {
  if (isDev()) {
    return process.env.NEXT_PUBLIC_STATS_SITE_ORIGIN_DEV;
  } else if (process.env.NEXT_PUBLIC_ENV === "production") {
    return process.env.NEXT_PUBLIC_STATS_SITE_ORIGIN_PROD;
  } else if (process.env.NEXT_PUBLIC_ENV === "staging") {
    return process.env.NEXT_PUBLIC_STATS_SITE_ORIGIN_STAGING;
  }
};
